import type { LogoCard } from "../types";
import { formatBytes } from "../utils/formatBytes";

export const LogoCardItem: React.FC<LogoCard> = ({
  id,
  name,
  countryId,
  country,
  svg,
  png,
}) => {
  return (
    <div className="flex flex-col items-center justify-center rounded-md border border-neutral-200 p-4 hover:bg-neutral-100/50 dark:border-neutral-800 dark:hover:bg-neutral-800/20">
      <a
        href={`/${countryId}/${id}/`}
        className="flex flex-col items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring dark:focus-visible:ring-offset-neutral-900 focus-visible:ring-offset-2 active:translate-y-0.5 z-10"
      >
        <img
          srcSet={`
          /logos/${countryId}/64x64/${id}.png 1x,
          /logos/${countryId}/128x128/${id}.png 2x,
          /logos/${countryId}/256x256/${id}.png 3x,
          /logos/${countryId}/512x512/${id}.png 4x
        `}
          src={`/logos/${countryId}/128x128/${id}.png`}
          className="w-[64px] h-[64px] mb-2"
          width={64}
          height={64}
          alt={`${name} (${country}) logo`}
          decoding="async"
          loading="lazy"
        />
        <h3 className="truncate text-balance text-center text-base font-medium mb-1">
          {name}
        </h3>
      </a>
      <a
        href={`/${countryId}/`}
        className="bg-neutral-200 dark:bg-neutral-700 rounded-full text-xs py-[2px] px-[6px] mb-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring dark:focus-visible:ring-offset-neutral-900 focus-visible:ring-offset-2 active:translate-y-0.5"
      >
        {country}
      </a>
      <div className="flex items-center gap-3">
        <div className="relative inline-block">
          <select
            name="category"
            className="dark:bg-neutral-900 h-[32px] w-[98px] appearance-none p-0 border-none bg-none text-transparent rounded-md cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 active:translate-y-0.5 hover:bg-accent dark:hover:bg-zinc-800 dark:focus-visible:ring-offset-neutral-900"
            onChange={(e) => {
              const value = e.target.value;

              const link = document.createElement("a");
              link.href = `/logos/${countryId}/${value}x${value}/${id}.png`;
              link.download = `${countryId}_${id}_${value}x${value}.png`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              console.log(value);
            }}
          >
            <option value="" disabled selected>
              Select size to download
            </option>
            {png.map((size) => (
              <option value={size.dimension} key={size.dimension}>
                {size.dimension}x{size.dimension} ({formatBytes(size.sizeBytes)}
                )
              </option>
            ))}
          </select>
          <div className="absolute inset-0 pointer-events-none inline-flex items-center justify-center gap-2 whitespace-nowrap text-xs font-medium disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border bg-background hover:bg-accent hover:text-accent-foreground rounded-md px-3 dark:border-neutral-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="h-3 w-3"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" x2="12" y1="15" y2="3"></line>
            </svg>
            PNG
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="h-3 w-3"
            >
              <path d="m6 9 6 6 6-6"></path>
            </svg>
          </div>
        </div>
        {svg && (
          <a
            href={`/logos/${countryId}/${id}.svg`}
            download={`${countryId}_${id}.svg`}
            className="bg-white dark:bg-neutral-900 inline-flex items-center justify-center gap-2 whitespace-nowrap text-xs font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring dark:focus-visible:ring-offset-neutral-900 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input dark:border-neutral-500 bg-background hover:bg-zinc-100 dark:hover:bg-zinc-800 h-[32px] rounded-md px-3 active:translate-y-0.5"
            aria-label={`Download ${name} (${country}) svg logo`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="h-3 w-3"
            >
              <>
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" x2="12" y1="15" y2="3" />
              </>
            </svg>
            SVG
          </a>
        )}
      </div>
    </div>
  );
};
